export default "__VITE_ASSET__DF$5Q9te__"